<script>
    import SearchAccountWidget from "./SearchAccountWidget.svelte";
    import { onMount, beforeUpdate, afterUpdate } from 'svelte';
    import { post } from './lib/Request.svelte';

    onMount(async () => {
        window.$('[data-toggle="popover"]').popover();
    });
    afterUpdate(() => {
        window.$('[data-toggle="popover"]').popover();
    });

    export let analyzeId;
    export let recommends = [];
    export let selectedUsers = [];

    export let afterSave;

    let isLoading = false;
    let isDisabled = (selectedUsers.length === 0);

    const avatarWidth = 70;

    function selectUser(item) {
        if (selectedUsers && selectedUsers.length >= 10) return;

        const alreadyFound = selectedUsers.find(obj => {
            return obj.id === Number(item.id);
        });

        if (!alreadyFound) {
            selectedUsers.push({
                id: Number(item.id),
                username: item.username,
                photo: item.photo,
            });
        }
        selectedUsers = selectedUsers;
        isDisabled = (selectedUsers.length === 0);
    }

    function removeUser(item) {
        for (let i = 0; i < selectedUsers.length; i++) {
            if (selectedUsers[i].id === item.id) {
                selectedUsers.splice(i, 1);
                break;
            }
        }

        selectedUsers = selectedUsers;
        isDisabled = (selectedUsers.length === 0);
    }

    async function saveList() {
        if (isLoading || selectedUsers.length === 0) {
            return;
        }

        isLoading = true;
        const response = await post('/instashpion/api/update-relations-circle', {
            analyze_id: analyzeId,
            selected_users: JSON.stringify(selectedUsers),
        });
        console.log(response);

        try {
            const analyzeIndex = window._sharedData.analyzes.map(e => e.id).indexOf(analyzeId);
            window._sharedData.analyzes[analyzeIndex].relationsCircle = selectedUsers;
        } catch (err) {
            console.log(err);
        }
        isLoading = false;

        try {
            if (typeof afterSave === 'function') {
                afterSave();
            }
        } catch (err) {
            console.log(err);
        }
    }

</script>



<div class="inner-wrap">
    <div class="description-wrap mb-20px">
        Здесь вы можете выбрать до 10 инстаграм-аккаунтов, и в дальнейшем сервис будет отслеживать взаимодействия интересующего вас пользователя именно с ними:
    </div>

    <div class="content-wrap test-block">
        <div class="content-inner-block ">
            <div class="title-wrap mb-12px">Введите название аккаунта</div>
            <div class="search-wrap bottom-bordered mb-20px pt-12px pb-25px">
                <SearchAccountWidget selectedUsers={selectedUsers} selectUser={selectUser} />
            </div>
        </div>

        <div class="content-inner-block ">
            <div class="title-wrap mb-12px">Рекомендуемые</div>
            <div class="recommends-wrap bottom-bordered mb-20px pb-25px">
                <div class="items-wrap clearfix" style={`width: ${recommends.length * avatarWidth}px;`}>
                    {#if recommends.length > 0}
                        {#each recommends as item}
                            <div class="user-select-wrap position-relative mr-10px"
                               type="button"
                               data-toggle="popover"
                               data-placement="top"
                               data-content={`@${item.username}`}
                            >
                                <div class="avatar-wrap circle">
                                    <img src={item.photo} />
                                </div>
                                <a class="plus-wrap position-absolute circle" on:click={selectUser(item)}>+</a>
                            </div>
                        {/each}
                    {/if}
                </div>
            </div>
        </div>

        <div class="content-inner-block ">
            <div class="title-wrap mb-12px">Круг взаимодействий ({selectedUsers.length}/10)</div>
            <div class="selected-users-wrap pt-12px pb-25px">
                {#if selectedUsers.length > 0}
                    <div class="items-wrap clearfix" style={`width: ${selectedUsers.length * avatarWidth}px;`}>
                        {#each selectedUsers as item}
                            <div class="user-select-wrap position-relative mr-10px"
                               type="button"
                               data-toggle="popover"
                               data-placement="top"
                               data-content={`@${item.username}`}
                            >
                                <div class="avatar-wrap circle">
                                    <img src={item.photo} />
                                </div>
                                <a class="remove-wrap position-absolute circle" on:click={removeUser(item)}>x</a>
                            </div>
                        {/each}
                    </div>
                {:else }
                    <div class="empty-list-message">
                        Список пуст
                    </div>
                {/if}
            </div>
        </div>
    </div>

    <div class="controls-wrap mb-30px">
        <a href="#" on:click={saveList} class="btn btn-big btn-success {isDisabled ? 'disabled' : ''}">
            Сохранить список
            <img src="/spy30-landing/assets/images/spinner.svg" alt="search" class={isLoading ? 'main__banner-spinner_icon' : 'hide'} />
        </a>
    </div>
</div>


<style>
    .pt-12px {
        padding-top: 12px;
    }
    .pb-25px {
        padding-bottom: 25px;
    }
    .mr-10px {
        margin-right: 10px;
    }
    .mb-12px {
        margin-bottom: 12px;
    }
    .mb-20px {
        margin-bottom: 20px;
    }
    .mb-30px {
        margin-bottom: 30px;
    }
    .position-relative {
        position: relative;
    }
    .position-absolute {
        position: absolute;
    }
    .circle {
        border-radius: 50%;
        overflow: hidden;
    }
    .plus-wrap:hover, .remove-wrap:hover {
        text-decoration: none;
        color: #fff;
    }
    .plus-wrap, .remove-wrap {
        width: 21px;
        height: 21px;
        top: 0;
        right: 0;
        color: #fff;
    }
    .plus-wrap {
        background: #009C42;
    }
    .remove-wrap {
        background: #FF0000;
    }
    .description-wrap {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 300;
        font-size: 18px;
        text-align: center;
        line-height: 21px;
        color: #4F4F4F;
    }
    .empty-list-message {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        color: #777777;
    }
    .content-wrap {
        padding: 20px;
    }
    .content-inner-block .title-wrap {
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        text-align: center;
        color: #333333;
    }
    .recommends-wrap, .selected-users-wrap {
        overflow-x: scroll;
        overflow-y: hidden;
    }
    .recommends-wrap .items-wrap, .selected-users-wrap .items-wrap {

    }
    .user-select-wrap {
        float: left;
        width: 60px;
        height: 60px;
    }
    .bottom-bordered {
        border-bottom: 0.5px solid #8A8585;
    }
    .main__banner-spinner_icon {
        width: 20px;
    }
</style>